var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 78,
    viewBox: "0 0 152 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 0C22.2567 0.952301 0 39 0 39C0 39 22.2567 77.0477 76 78C129.744 77.0477 152 39 152 39C152 39 129.744 0.952301 76 0Z",
    fill: "#D8ECFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.543 27.3365C143.242 28.3589 143.584 28.9431 143.584 28.9431C143.584 28.9431 121.328 66.9908 67.5842 67.9434C33.5667 67.3405 12.1689 51.8778 1.04053 40.6069C5.99032 47.8487 28.9058 77.1654 75.9997 78C129.743 77.0477 152 39 152 39C152 39 148.996 33.8722 142.543 27.3365Z",
    fill: "#C4E2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9999 78C97.628 78 115.161 60.5391 115.161 39C115.161 17.4609 97.628 0 75.9999 0C54.3719 0 36.8389 17.4609 36.8389 39C36.8389 60.5391 54.3719 78 75.9999 78Z",
    fill: "#0182FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0003 60.7891C63.9359 60.7891 54.1206 51.0145 54.1206 38.9997C54.1206 26.9846 63.9356 17.21 76.0003 17.21C88.0647 17.21 97.8797 26.9846 97.8797 38.9997C97.8797 51.0145 88.0647 60.7891 76.0003 60.7891Z",
    fill: "#465A61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0675 36.5271C83.2309 36.5271 78.4824 31.7981 78.4824 25.9855C78.4824 20.1727 83.2309 15.444 89.0675 15.444C94.9041 15.444 99.6526 20.173 99.6526 25.9855C99.6523 31.7981 94.9041 36.5271 89.0675 36.5271Z",
    fill: "#D8ECFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1783 6.85571C102.519 13.1354 105.063 20.7429 105.063 28.9428C105.063 50.4821 87.5294 67.9428 65.9015 67.9428C57.6674 67.9428 50.0285 65.41 43.7231 61.0869C50.7846 71.3018 62.6059 77.9998 76 77.9998C97.6282 77.9998 115.161 60.5388 115.161 38.9998C115.161 25.6608 108.435 13.8878 98.1783 6.85571V6.85571Z",
    fill: "#0172FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.03589ceae5504e153d13f45a23909009.svg";
export { ForwardRef as ReactComponent };